import './../../assets/css/common/custom-alert.scss';
import React, { Component } from "react";
import { Alert } from 'react-bootstrap';

class CustomAlert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: true
        };
    }

    close = () => {
        this.setState({ show: false });
    }

    render() {
        const { children, handleClose, variant, customStyle, irremovable } = this.props
        const onClose = handleClose || this.close

        return (
            <div className='custom-alert'>
                {this.state.show ? <Alert className={customStyle} variant={variant} onClose={onClose} dismissible={!irremovable}>
                    {children}
                </Alert> : null}
            </div>
        );
    }
}

export default CustomAlert;